import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=36882f98&scoped=true&lang=pug&"
import script from "./InputSelect.vue?vue&type=script&lang=js&"
export * from "./InputSelect.vue?vue&type=script&lang=js&"
import style0 from "./InputSelect.vue?vue&type=style&index=0&id=36882f98&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36882f98",
  null
  
)

export default component.exports